// @flow

import createAction from 'redux-actions/lib/createAction';

// -----------------------------------------------------------------------------------------------------------------
// Types
// -----------------------------------------------------------------------------------------------------------------

type HidePersonalisedDataClearedMessageActionType = 'PERSONAL_CONTENT:HIDE_PERSONALISED_DATA_CLEARED_MESSAGE';

export type HidePersonalisedDataClearedMessageAction = {|
  type: HidePersonalisedDataClearedMessageActionType,
  payload: {||},
  meta: {||},
|};


// -----------------------------------------------------------------------------------------------------------------
// Constants
// -----------------------------------------------------------------------------------------------------------------

const type: HidePersonalisedDataClearedMessageActionType = 'PERSONAL_CONTENT:HIDE_PERSONALISED_DATA_CLEARED_MESSAGE';


// -----------------------------------------------------------------------------------------------------------------
// Action
// -----------------------------------------------------------------------------------------------------------------

const hidePersonalisedDataClearedMessage: (void) => HidePersonalisedDataClearedMessageAction = createAction(type);


// -----------------------------------------------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------------------------------------------

export default hidePersonalisedDataClearedMessage;



// WEBPACK FOOTER //
// ./src/modules/personalContent/store/actions/hidePersonalisedDataClearedMessage.js